import { FrontEndAppSettingsService } from '../services/frontEndAppSettings'

class InternalFrontEndAppSettings {
  constructor () {
    this.initRun = false
    this._localStorageKeys = []
    this.globalSettings = {}
    this.featureFlags = {}
    this.customerPreferences = {}
  }

  setSettings (settings) {
    this.globalSettings = settings.GlobalSettings || {}
    this.featureFlags = settings.FeatureFlags || {}
    this.mapCustomerPreference(settings.CustomerPerferences || [])
  }

  mapCustomerPreference (cp) {
    this.customerPreferences = cp.reduce((acc, pref) => {
      acc[pref.preferenceType] = pref.enabled
      return acc
    }, {})
  }

  async getSettings () {
    return await FrontEndAppSettingsService.getSettings()
  }

  getLocalStorageSettings () {
    // assumes that the settings are ints
    // because cshtml files were making bools capital..?
    return this._localStorageKeys.reduce((acc, n) => {
      acc[n] = !!parseInt(window.localStorage.getItem(n))
      return acc
    }, {})
  }

  mergeSettings (...settings) {
    return settings.reduce((acc, n) => ({ ...acc, ...n }), {})
  }

  async init () {
    if (this.initRun) {
      console.warn('[FrontEndAppSettings] init has already been performed.')
      return
    }
    this.initRun = true
    const settings = await this.getSettings() || {}
    const localSettings = this.getLocalStorageSettings()
    return this.mergeSettings(localSettings, settings)
  }
}

export const FrontEndAppSettings = new InternalFrontEndAppSettings()
